<template>
  <el-dialog
    id="SampleAddOrUpdate"
    :title="!sampleId ? user.hospital.hospitalName+'外送标本申请单录入' : user.hospital.hospitalName+'外送标本申请单修改'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @closed="close()">
    <el-row>
      <el-col :span="12">
        <p class="title"><i class="el-icon-edit-outline"></i>基本信息</p>
        <el-form ref="dataForm" :model="dataForm" :rules="dataRule" :inline="true" label-width="100px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="条形码" prop="hospCode">
                <el-input v-model="dataForm.hospCode">
                  <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="护照号" prop="passportNo">
                <el-input v-model="dataForm.passportNo">
                  <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="姓名" prop="realName">
                <el-input v-model="dataForm.realName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="性别" prop="sex">
                <el-radio label="1" v-model="dataForm.sex">男</el-radio>
                <el-radio label="0" v-model="dataForm.sex">女</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="身份证号" prop="cardId">
                <el-input v-model="dataForm.cardId" @blur="calculateBirth"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                  v-model="dataForm.birthday"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :editable="false"
                  :picker-options="picker_birthday">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="年龄" prop="age">
                <el-input v-model.number="dataForm.age"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="dataForm.mobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
      <el-col :span="12">
        <p class="title"><i class="el-icon-edit-outline"></i>检验信息</p>
        <el-form ref="dataForm2" :model="dataForm2" :rules="dataRule2" :inline="true" label-width="100px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="送检检验所" v-if="sampleId || itemId_">
                {{providerName}}
              </el-form-item>
              <el-form-item label="送检检验所" prop="providerId" v-else>
                <el-select v-model="dataForm2.providerId" filterable placeholder="请选择" @change="selectProvider" clearable>
                  <el-option
                    v-for="(item, index) in options_provider"
                    :key="item.id"
                    :label="item.providerName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="检验项目" v-if="sampleId || itemId_">
                {{itemName}}
              </el-form-item>
              <el-form-item label="检验项目" prop="itemId" v-else>
                <el-select v-model="dataForm2.itemId" filterable placeholder="请选择" @change="selectItem" clearable>
                  <el-option
                    v-for="item in options_item"
                    :key="item.id"
                    :label="item.itemName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="标本类型" prop="sampleType">
                <el-select v-model="dataForm2.sampleType" filterable placeholder="请选择" clearable>
                  <el-option
                    v-for="(item,index) in options_sampleType"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="测试方法" prop="testMethod">
                <el-select v-model="dataForm2.testMethod" filterable placeholder="请选择" clearable>
                  <el-option
                    v-for="(item,index) in options_testMethod"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="保存条件">
                {{TS}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="报告方式">
                {{reportType}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="标本数量" prop="sampleNum">
                <el-input v-model="dataForm2.sampleNum"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="采集时间" prop="submitTime">
                <el-date-picker
                  v-model="dataForm2.submitTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"
                  :editable="false"
                  :picker-options="picker_submitTime">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <p class="title"><i class="el-icon-edit-outline"></i>其他信息</p>
        <el-form ref="dataForm3" :model="dataForm3" :rules="dataRule3" :inline="true" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="送检科室">
                <el-select v-model="dataForm3.keshi" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in options_keshi"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="病区" prop="bingqu">
                <el-input v-model="dataForm3.bingqu"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="床号" prop="chuanghao">
                <el-input v-model="dataForm3.chuanghao"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="dataForm3.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="border">
            <el-col :span="12">
              <el-form-item label="送检医师" prop="submitPhysician">
                <el-input v-model="dataForm3.submitPhysician"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="录入人员" prop="operator">
                <el-input v-model="dataForm3.operator"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="operate_btn">
        <template v-if="sampleId">
          <el-button @click="save(2)" :loading="loading" :disabled="loading">保存修改</el-button>
        </template>
        <template v-else>
          <el-checkbox class="next" v-model="nextFlag">保存并继续下一个</el-checkbox>
          <el-button type="primary" @click="save(1)" :loading="loading" :disabled="loading">保存</el-button>
        </template>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
    import axios from 'axios'

    export default {
      name: "sample-add-or-update",
      data() {
        return {
          clickTag: 0,//重复保存标志
          loading: false,
          visible: false,
          nextFlag: false,//是否继续录入
          providerName:'',//送检检验所
          itemName:'',//检验项目
          reportType:'无',//报告方式
          TS:'无',//运输条件
          sampleId:'',//标本编号
          orderId:'',//订单id
          orderNum:'',//订单编号
          detailItemId:'',//订单详情id
          itemId_:'',//项目id
          //基本信息
          dataForm: {
            hospCode:'',
            passportNo: '',
            realName:'',
            sex:'1',
            cardId:'',
            birthday:'',
            mobile:'',
            age: '',
          },
          //检验信息
          dataForm2:{
            providerId:'',
            itemId:'',//暂时不能修改
            sampleType:'',
            testMethod:'',
            sampleNum:'1',
            submitTime:''
          },
          //其他信息
          dataForm3: {
            keshi:'',
            bingqu:'',
            chuanghao:'',
            remark:'',
            submitPhysician:'',
            operator:this.$store.state.user.name,
          },
          dataRule: {
            hospCode: [
              { pattern: /^([A-Za-z0-9()（）]+)$/, message: '条形码格式有误', trigger: 'blur' },
              { max: 20, message: '长度不能超过20个字符', trigger: 'blur' },
            ],
            // realName: [
            //   { required: true, message: '姓名不能为空', trigger: 'blur' },
            //   { max: 8, message: '长度不能超过8个字符', trigger: 'blur' },
            //   { pattern: /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\ \s]{1,20})$/, message: '姓名格式有误', trigger: 'blur' }
            // ],
            sex: [
              { required: true, message: '性别不能为空', trigger: 'change' }
            ],
            cardId: [
              { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证格式有误', trigger: 'blur' }
            ],
            // birthday: [
            //   { required: true, message: '出生日期不能为空', trigger: 'change' }
            // ],
            // age: [
            //   { required: true, pattern: /^[1-9]\d?$|^1[0-4]\d$|^0$|^120$/, message: '年龄格式有误', trigger: 'blur' }
            // ],
            mobile: [

            ],
          },
          dataRule2: {
            providerId: [
              { required: true, message: '送检检验所不能为空', trigger: 'change' }
            ],
            itemId: [
              { required: true, message: '检验项目不能为空', trigger: 'change' }
            ],
            sampleType: [
              { required: true, message: '标本类型不能为空', trigger: 'change' }
            ],
            testMethod: [
              { required: true, message: '测试方法不能为空', trigger: 'change' }
            ],
            sampleNum: [
              // { message: '标本数量不能为空', trigger: 'blur' },
              { pattern: /^\+?[1-9][0-9]*$/, message: '数量必须为正整数' },
              { pattern:/^\d{1,20}$/, message: '长度不能超过20个字符', trigger: 'blur' }
            ],
            // submitTime: [
            //   { message: '采集时间不能为空', trigger: 'change' }
            // ]
          },
          dataRule3: {
            bingqu: [
              { pattern: /^([A-Za-z0-9()（）\u4e00-\u9fa5]+)$/, message: '病区格式有误', trigger: 'blur' },
              { max: 20, message: '长度不能超过20个字符', trigger: 'blur' },
            ],
            chuanghao: [
              { pattern: /^([A-Za-z0-9()（）\u4e00-\u9fa5]+)$/, message: '床号格式有误', trigger: 'blur' },
              { max: 20, message: '长度不能超过20个字符', trigger: 'blur' },
            ],
            remark: [
              { max: 100, message: '长度不能超过100个字符', trigger: 'blur' },
            ],
            operator: [
              { max: 10, message: '长度不能超过10个字符', trigger: 'blur' },
            ],
            submitPhysician: [
              { max: 10, message: '长度不能超过10个字符', trigger: 'blur' },
            ]
          },
          //出生日期选择限制
          picker_birthday: {
            disabledDate: time => {
              return (
                time.getTime() > new Date().getTime()
              )
            }
          },
          //采集时间选择限制
          picker_submitTime: {
            disabledDate: time => {
              return (
                time.getTime() > new Date().getTime()
              )
            }
          },
          //送检科室
          options_keshi: [],
          //标本类型
          options_sampleType: [],
          //测试方法
          options_testMethod: [],
          //标本性状
          options_sampleProperties: [],
          //检验项目
          options_item: [],
          //送检检验所
          options_provider:[]
        }
      },
      computed: {
        user() {
          return this.$store.state.user;
        },
      },
      methods: {
        //初始化 id:标本id
        init (id,detailItemId,_itemId) {
          let that = this
          this.sampleId = id
          this.detailItemId = detailItemId
          this.itemId_ = _itemId
          axios.all([
          axios.get('/jys/provider/ass'),
          axios.get("/jys/sample/hospSelect")
        ]).then(axios.spread(function (res1, res2) {
            if (res1.data.code == 0 && res2.data.code == 0) {
              that.options_provider = res1.data.list
              that.dataForm2.providerId = res1.data.list.length ? res1.data.list[0].id : ''
              that.dataForm2.itemId = ''
              that.selectProvider(that.dataForm2.providerId)
              that.options_keshi = res2.data.keshiList
              that.options_sampleProperties = res2.data.propList
              // that.options_sampleType = res2.data.typeList
              //上一条录入的标本信息的部分数据可以保留至下一条，例如送检检验所，送检科室等信息，避免重复录入操作
              // let providerId = localStorage.getItem('sampleAddOrUpdate-providerId')
              // let itemId = localStorage.getItem('sampleAddOrUpdate-itemId')
              //
              // setTimeout(function () {
              //   if(providerId&&providerId !== 'undefined'){
              //     that.dataForm2.providerId = parseInt(providerId)
              //     that.dataForm2.itemId = parseInt(itemId)
              //     that.selectProvider(providerId)
              //     that.selectItem(itemId)
              //   }else {
              //     that.dataForm2.providerId = ''
              //     that.dataForm2.itemId = ''
              //   }
              // },200)
            }
          })).then(() => {
            this.visible = true
          }).then(() => {
            if (this.sampleId) {
              axios.get("/jys/sample/hospInfo/" + this.sampleId,
              ).then(res => {
                  if(res.data.code == 0){
                    let sample = res.data.sample
                    this.dataForm.hospCode = sample.hospCode
                    this.dataForm.realName = sample.patientName
                    this.dataForm.sex = sample.patientSex+''
                    this.dataForm.cardId = sample.cardId
                    // this.dataForm.birthday = sample.patientBirthday
                    this.dataForm.age = sample.patientAge

                    this.dataForm.mobile = sample.patientTel
                    this.dataForm2.itemId = sample.itemId
                    this.dataForm2.sampleType = sample.sampleType
                    this.dataForm2.testMethod = sample.testMethod
                    this.dataForm2.sampleNum = sample.sampleNum
                    this.dataForm2.submitTime = sample.submitTime
                    this.dataForm3.keshi = sample.keshi
                    this.dataForm3.bingqu = sample.bingqu
                    this.dataForm3.chuanghao = sample.chuanghao
                    this.dataForm3.remark = sample.remark
                    this.dataForm3.submitPhysician = sample.submitPhysician
                    this.dataForm3.operator = sample.personnel

                    let ext = JSON.parse(sample.ext)
                    this.providerName= sample.providerName
                    this.itemName = sample.itemName
                    this.options_sampleType = ext.sampleType
                    this.dataForm2.sampleType = ext.sampleType.length ? ext.sampleType[0] : ''
                    this.options_testMethod = ext.testMethod
                    this.dataForm2.testMethod =  ext.testMethod.length ?  ext.testMethod[0] : ''
                    this.reportType = ext.reportType?(ext.reportType=='0'?'电子报告':'纸质报告'):'电子报告'
                    this.TS = ext.TS
                  }
                });
            }else if(this.itemId_){
              this.dataRule.mobile.push({ required: true, message: '手机号不能为空', trigger: 'blur' })
              axios.get("/jys/item/" + this.itemId_
              ).then((res) => {
                this.dataForm2.itemId = this.itemId_
                this.itemName = res.data.item.itemName
                let ext = JSON.parse(res.data.item.ext)
                this.options_sampleType = ext.sampleType
                this.options_testMethod = ext.testMethod
                this.reportType = ext.reportType?(ext.reportType=='0'?'电子报告':'纸质报告'):'电子报告'
                this.TS = ext.TS
              })
            }
            console.log('this.dataForm', this.dataForm)
          })
        },

        //选择检验所
        selectProvider (e) {
          this.options_item = []
          this.options_sampleType = []
          this.options_testMethod = []
          this.dataForm2.itemId = ''
          this.dataForm2.sampleType = ''
          this.dataForm2.testMethod = ''
          try {
            this.$refs['dataForm2'].clearValidate(['itemId','sampleType','testMethod'])
          } catch (e) {}
          this.TS = '无'
          this.reportType = '无'
          axios.get("/jys/item/pvdItem/" + e + "/3"
          ).then((res) => {
            if(res.data.code == 0){
              this.options_item = res.data.list
              this.dataForm2.itemId = res.data.list.length ? res.data.list[0].id : ''
              this.dataForm2.sampleType = ''
              this.dataForm2.testMethod = ''
              this.selectItem(this.dataForm2.itemId)
            }
          })
        },

        //选择检验项目
        selectItem (e) {
          this.options_sampleType = []
          this.options_testMethod = []
          this.dataForm2.sampleType = ''
          this.dataForm2.testMethod = ''
          let that = this
          let itemList = this.options_item
          for (let i = 0; i < itemList.length; i++) {
            if(e === itemList[i].id){
              let ext = JSON.parse(itemList[i].ext)
              that.options_sampleType = ext.sampleType
              this.dataForm2.sampleType = ext.sampleType.length ? ext.sampleType[0] : ''
              that.options_testMethod = ext.testMethod
              this.dataForm2.testMethod = ext.testMethod.length ? ext.testMethod[0] : ''
              that.reportType = ext.reportType?(ext.reportType=='0'?'电子报告':'纸质报告'):'电子报告'
              that.TS = ext.TS
            }
          }
        },

        //保存
        save (type) {
          console.log('this.dataForm.age', this.dataForm.age)

          let that = this
          if (this.clickTag == 0) {
            that.clickTag = 1
            that.loading = true
            setTimeout(function () {
              that.clickTag = 0
              that.loading = false
            }, 2000)
            this.$refs['dataForm'].validate((valid) => {
              this.$refs['dataForm2'].validate((valid2) => {
                if (valid && valid2) {
                  let url = ''
                  if(type == 2){
                    url = '/jys/sample/updateHosp'
                  }else{
                    if(this.detailItemId){
                      //订单-录入
                      url = '/jys/hospSample/save'
                      this.dataForm2.detailItemId = this.detailItemId
                    }else{
                      //样本管理-录入
                      url = '/jys/sample/saveHosp'
                    }
                  }
                  this.dataForm.sampleId = this.sampleId
                  // this.dataForm.sex = parseInt(this.dataForm.sex)
                  this.dataForm2.sampleNum = parseInt(this.dataForm2.sampleNum)
                  console.log('this.dataForm', this.dataForm)

                  axios.post(
                    url,
                    Object.assign({}, this.dataForm,this.dataForm2,this.dataForm3,{
                      realName: this.dataForm.realName || '空',
                      age: this.dataForm.age || 0
                    })
                  ).then((res) => {
                    if(res.data.code == 0){
                      this.$alert('保存标本信息成功', '提示', {
                          confirmButtonText: '确定',
                          showClose: false,
                          callback: action => {
                            if(!this.nextFlag){
                              //不继续录入
                              this.visible = false
                              this.close()
                              if(this.detailItemId){
                                //订单
                                this.orderId = res.data.orderId
                                this.orderNum = res.data.orderNum
                                this.$router.push({path: '/mine/sampleResult', query: {orderId: this.orderId, orderNum: this.orderNum, detailItemId: this.detailItemId, itemId: this.itemId_}})
                              }else{
                                //样本管理
                                this.$emit('refreshDataList')
                              }
                            }else{
                                //继续录入
                              this.reset()
                              this.$emit('refreshDataList')
                              //为下一条保留记录
                              // localStorage.setItem('sampleAddOrUpdate-providerId',this.dataForm2.providerId);
                              // localStorage.setItem('sampleAddOrUpdate-itemId',this.dataForm2.itemId);
                            }
                          }
                      });
                    }
                  })
                }
              })
            })
          }
          else{
            this.$message({
              showClose: true,
              message: '请勿重复操作！',
              type: 'warning'
            })
          }
        },

        //重置，将其值重置为初始值并移除校验结果
        reset(){
          this.$refs['dataForm'].resetFields();
          this.$refs['dataForm3'].resetFields();
        },

        close(){
          this.$emit('refreshDataList')
          this.$refs['dataForm'].resetFields();
          this.$refs['dataForm2'].resetFields();
          this.$refs['dataForm3'].resetFields();
          // localStorage.removeItem('sampleAddOrUpdate-providerId')
          // localStorage.removeItem('sampleAddOrUpdate-itemId')
          this.dataForm3.keshi = ''
          this.dataForm3.bingqu = ''
          this.reportType = '无'
          this.TS = '无'
        },

        //根据身份证号计算生日
        calculateBirth(){
          this.$refs['dataForm'].validateField('cardId',(valid) => {
            if(valid === ''){
              let idCard = this.dataForm.cardId
              let birthday = ''
              if (idCard !== null && idCard !== '') {
                if (idCard.length === 15) {
                  birthday = '19' + idCard.substr(6, 6)
                } else if (idCard.length === 18) {
                  birthday = idCard.substr(6, 8)
                }
                birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
              }
              this.dataForm.birthday = birthday
            }
          })
        }
      }
    }
</script>

<style scoped>
  #SampleAddOrUpdate >>> .el-dialog__header{
    text-align: center;
  }
  #SampleAddOrUpdate >>> .el-dialog__title{
    color: #000000;
    font-size: 17px;
    font-weight: bold;
  }
  #SampleAddOrUpdate .el-row{
    margin-bottom: 0;
  }
  .title{
    color: #93A2B7;
    margin-bottom: 15px;
  }
  .el-icon-edit-outline{
    padding-right: 5px;
  }
  .el-form >>> .el-row{
    margin-bottom: 0;
  }
  .el-form-item,
  .el-select,
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner{
    width: 100%;
  }
  .el-form-item >>> .el-form-item__label{
    font-weight: bold;
  }
  .el-form-item >>> .el-form-item__content{
    width: 50%;
  }
  .el-form-item >>> .el-input__inner{
    border-color: #D4D4D4;
    padding-left: 10px;
  }
  .el-form-item >>> .el-input-group__append{
    color: #ffffff;
    background-color: #00C5B0;
    border-color: #00C5B0;
    padding: 0 15px;
  }
  .el-form-item >>> .el-input.is-disabled .el-input__inner{
    color: #626469;
    background-color: #ffffff;
    border: none;
  }
  .el-form-item >>> .el-input.is-disabled .el-input__suffix{
    display: none;
  }
  .el-form-item >>> .el-input--prefix .el-input__inner{
    padding-left: 30px;
  }
  .el-form-item >>> .el-textarea__inner{
    padding: 5px 10px;
  }
  .operate_btn{
    text-align: center;
  }
  .next{
    margin-right: 15px;
  }
  .border{
    padding-top: 25px;
    border-top:1px solid #D4D4D4;
  }
</style>



// WEBPACK FOOTER //
// src/components/sample-add-or-update-bk.vue